export type DropPosition = 'top' | 'bottom'

/**
 * The account order after dropping the profile at `fromIndex` above or below
 * the profile at `dropIndex`, or `null` when that is not a move (dropped on
 * itself, or either index is out of range).
 *
 * Lives outside the sidebar because both the mouse drop and the touch drop
 * end here, and because an order this gets wrong is written straight to the
 * backend — cheaper to assert on than to click through.
 */
export function reorderedAccounts(
  accounts: number[],
  fromIndex: number,
  dropIndex: number,
  position: DropPosition
): number[] | null {
  const inRange = (i: number) => i >= 0 && i < accounts.length
  if (!inRange(fromIndex) || !inRange(dropIndex) || fromIndex === dropIndex) {
    return null
  }

  const reordered = accounts.slice()
  const [moved] = reordered.splice(fromIndex, 1)
  // Can't happen after the range check above, but this file is also compiled
  // with `noUncheckedIndexedAccess` (the mocha run), which can't know that.
  if (moved === undefined) {
    return null
  }

  let targetIndex = dropIndex
  if (fromIndex < dropIndex) {
    targetIndex--
  }
  if (position === 'bottom') {
    targetIndex++
  }

  reordered.splice(targetIndex, 0, moved)
  return reordered
}
